<template>
	<div class="contatiner">
		<!-- <div class="top">
			<div class="title">研小白-小白考研</div>
			<img class="top_img" src="../../../../static/h1.png" alt="">
			<div class="text1">可分别选择院校群&专业群添加哦</div>
			<div class="text2">免费资料｜考研干货｜考研资讯｜信息共享</div>
		</div> -->
		<img v-if="isImg" class="IMG" :src="IMG" alt="">
		<div class="content">
			<van-tabs v-model="active" swipeable animated>
				<van-tab v-for="(item,index) in menuData" :title="item.name">
					<div class="school_group " v-if="item.id==1">
						<van-search class="van_search" v-model="searchValuee" show-action placeholder="请输入专业名检索" @input="onSearche"
						 @cancel="onCancele" />
						<div class="problem" v-if="!findActivityByType.length" @click="goFeedback">没有你的报考院校？<span>点我解决！</span></div>
						<van-collapse v-model="activeNamese" accordion class="van_search">
							<van-collapse-item class="van_li" v-for="(e ,index) in findActivityByType" v-if="e.list.length!==0" :name="index">
								<template #title>
									<div class="h4">{{e.pmc}} <span class="group_span">{{e.list.length}}</span></div>
								</template>
								<div class="li" v-for="(i ) in e.list " @click="onClickCart($event, i.code, i.title,i,'qq',1,lei)">
									{{i.title}}
								</div>
							</van-collapse-item>
						</van-collapse>
					</div>
					<div class="school_group " v-if="item.id==2">
						<van-search class="van_search" v-model="searchValueess" show-action placeholder="请输入专业名检索" @input="onSearchess"
						 @cancel="onCanceless" />
						<div class="problem" v-if="!findActivityByTypes.length" @click="goFeedback">没有你的报考院校？<span>点我解决！</span></div>
						<van-collapse v-model="activeNamesess" accordion class="van_search">
							<van-collapse-item class="van_li" v-for="(e ,index) in findActivityByTypes" v-if="e.list.length!==0" :name="index">
								<template #title>
									<div class="h4">{{e.pmc}} <span class="group_span">{{e.list.length}}</span></div>
								</template>
								<div class="li" v-for="(i ) in e.list " @click="onClickCart($event, i.code, i.title,i,'qq',2,lei)">
									{{i.title}}
								</div>
							</van-collapse-item>
						</van-collapse>
					</div>
					<div class="school_group" v-if="item.id==3">
						<van-search class="van_search" v-model="searchValue" show-action placeholder="请输入学校名检索" @input="onSearch" @cancel="onCancel" />
						<div class="problem" v-if="!findActivitydata.length" @click="goFeedback">没有你的报考院校？<span>点我解决！</span></div>
						<van-collapse v-model="activeNames" accordion class="van_search">
							<van-collapse-item class="van_li" v-for="(e ,index) in findActivitydata" v-if="e.list.length!==0" :name="index">
								<template #title>
									<div class="h4">{{e.pmc}} <span class="group_span">{{e.list.length}}</span></div>
								</template>
								<div class="li" v-for="(i ) in e.list " @click="onClickCart($event, i.code, i.title,i,'qq',0,lei)">
									{{i.schMc}}
								</div>
							</van-collapse-item>
						</van-collapse>
					</div>
					<!-- <div v-if="item.id==1 || item.id==2 || item.id==3" class="school_group_text">
						同学们，为了助力22考研人成功上岸，提供更有价值的信息和服务，将调整社群结构，院校及专业群将于5月17号重新开放噢～可以先进研友群交流哈！
					</div> -->
					<div class="school_group" v-if="item.id==4">
						<!-- <van-search class="van_search" v-model="searchValueYY" show-action placeholder="请输入相关词语检索" @input="onSearchYY" @cancel="onCancelessYY"  />
						<div class="problem" v-if="!findActivityYYdata.length" @click="goFeedback">没有你的报考院校？<span>点我解决！</span></div>
						<van-collapse v-model="activeNamesYY" accordion class="van_search">
							<van-collapse-item class="van_li" v-for="(e ,index) in findActivityYYdata" v-if="e.list.length!==0" :name="index">
								<template #title>
									<div class="h4">{{e.pmc}} <span class="group_span">{{e.list.length}}</span></div>
								</template>
								<div class="li" v-for="(i ) in e.list " @click="onClickCart($event, i.code, i.title,i,'qq',3,lei)">
									{{i.title}}
								</div>
							</van-collapse-item>
						</van-collapse> -->
						<!-- 	<div class="tab_iv">
							<div :class=" index == currentYY ? 'yes':''" v-for="(e,index) in YYData" @click="currentYY=index">{{e.title}}</div>
						</div> -->

						<div class="" v-for="(e,index) in YYData">
							<div class="titleD">{{e.title}}</div>
							<div class="yyImg" v-if="e.wxUrl">
								<img @touchstart="touchstart(e.wxUrl)" @touchend="touchend(e.wxUrl)" @touchmove="touchmove(e.wxUrl)"
								 @touchcancel="touchcancel(e.wxUrl)" :src="e.wxUrl" alt="">
							</div>
							<div class="yyImg" v-else>
								<img @touchstart="touchstart(e.url_img)" @click="imgClick(e.url_img)" @touchend="touchend(e.url_img)"
								 @touchmove="touchmove(e.url_img)" @touchcancel="touchcancel(e.url_img)" :src="e.url_img" alt="">
							</div>
							<div class="yyText" v-if="e.wxUrl">
								长按二维码加群
							</div>
							<div v-else>
								<div class="yyText">
									QQ群号：{{e.qq}}
								</div>
								<div class="yyBtn" @click="goqq(e.qqUrl)">点我跳转加群</div>
								<div v-if="e.qq" class="yyBtn" @click="copy($event, e.qq)">点我复制qq群</div>
							</div>
						</div>

						<!-- <div class="yyText" v-else>
							QQ群号：{{YYData[currentYY].qq}}
						</div> -->
						<!-- <div v-if="YYData[currentYY].qqUrl" class="yyBtn" @click="goqq(YYData[currentYY].qqUrl)" >点我跳转加群</div>
						<div v-if="!YYData[currentYY].qqUrl && YYData[currentYY].qq" class="yyBtn" @click="copy($event, YYData[currentYY].qq)" >点我复制qq群</div> -->
					</div>
				</van-tab>
			</van-tabs>
		</div>
		<div class="textdi" @click="copy($event, introduce.kf)">进群问题 可联系客服</div>
	</div>
	</div>
</template>

<script>
	import {
		Cell,
		CellGroup,
		Field,
		Image,
		Loading,
		Button,
		Notify,
		NoticeBar,
		Grid,
		GridItem,
		Toast,
		Icon,
		Collapse,
		CollapseItem,
		Search,
		Tab,
		Tabs,
		Dialog 
	} from 'vant';
	import QRCode from "qrcode"
	import https from '../../../https'
	import zwt from '../../../../static/no-data.jpg'

	export default {
		components: {
			[Dialog.name]: Dialog,
			[Cell.name]: Cell,
			[Field.name]: Field,
			[CellGroup.name]: CellGroup,
			[Image.name]: Image,
			[Loading.name]: Loading,
			[Button.name]: Button,
			[Notify.name]: Notify,
			[NoticeBar.name]: NoticeBar,
			[Grid.name]: Grid,
			[GridItem.name]: GridItem,
			[Icon.name]: Icon,
			[Collapse.name]: Collapse,
			[CollapseItem.name]: CollapseItem,
			[Search.name]: Search,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,

		},
		data() {
			return {
				active: 0,
				searchValue: "",
				searchValuee: "",
				searchValueess: "",
				searchValueYY: "",
				activeNames: -1,
				activeNamese: -1,
				activeNamesess: -1,
				activeNamesYY: 0,
				isFirstLoad: true,
				c: undefined,
				code: '',
				name: '',
				qr: undefined,
				zwt,
				loading: false,
				introduce: {},
				activeId: '',
				current: 1,
				lei: 0,
				findActivitydata: [],
				findActivityByType: [],
				findActivityByTypes: [],
				findActivityYYdata: [],
				menuData: [

					{
						name: "研友群",
						id: 4
					},
					{
						name: "院校群",
						id: 3
					}, {
						name: "学硕群",
						id: 1
					},
					{
						name: "专硕群",
						id: 2
					},
				],
				currentYY: 0,
				YYData: [{
					url_img: "",
				}],
				IMG: "",
				isImg: false,
			};
		},

		created() {
			// Dialog.alert({
			//   message: '院校专业群正在维护中，预计2月24日重新开放',
			// }).then(() => {
			//   // on close
			// });
			this.lei = this.$route.query.lei
			let c = this.$route.query.c
			this.activeId = this.$route.params && this.$route.params.id
			if (c) {
				this.c = c
				this.getCode(c)
			}
			// /api/feedback
			this.getActivity()

			var storage = window.sessionStorage;
			// this.active = parseInt(storage.getItem('tab'));
			// console.log("123", this.active,storage.getItem('lei'))
		},

		methods: {
			touchstart(e) {
				this.showTempQrCodeImg(e);
			},
			touchend(e) {
				this.dismissTempQrCodeImg(e);
			},
			touchmove(e) {
				this.dismissTempQrCodeImg(e);
			},
			touchcancel(e) {
				this.dismissTempQrCodeImg(e);
			},
			imgClick(e) {
				console.log(e)
			},
			showTempQrCodeImg(e) {
				let thia = this;
				let IMG = e; -
				setTimeout(function(e) {
					thia.IMG = IMG;
					thia.isImg = true;
				}, 300);
			},
			dismissTempQrCodeImg(e) {
				let thia = this;
				setTimeout(function(e) {
					thia.isImg = false;
				}, 1000);
			},
			goqq(e) {
				window.location.href = e;
			},
			goFeedback() {
				var thia = this
				this.$router.push({
					name: 'feedback',
					query: {
						name: thia.searchValue,
					}

				})
			},
			onSearche() {
				// console.log("回车", this.searchValuee)
				var findData = this.fuzzyQuery(this.findActivityByType22, this.searchValuee, 1)
				this.findActivityByType = findData
				this.activeNamese = 0
			},
			onSearchess() {
				// console.log("回车", this.searchValueess)
				var findData = this.fuzzyQuery(this.findActivityByTypess, this.searchValueess, 1)
				this.findActivityByTypes = findData
				this.activeNamesess = 0
			},
			onSearch() {
				// console.log("回车", this.searchValue)
				var findData = this.fuzzyQuery(this.findActivity22, this.searchValue, 2)
				this.findActivitydata = findData
				this.activeNames = 0
			},
			onSearchYY() {
				console.log("回车", this.searchValueYY)
				var findData = this.fuzzyQuery(this.findActivityYY, this.searchValueYY, 1)
				this.findActivityYYdata = findData
				this.activeNamesYY = 0
			},
			fuzzyQuery(list, keyWord, s) {
				var arr2 = [];
				for (var i = 0; i < list.length; i++) {
					var lists = list[i].list
					var arr = [];
					for (var e in lists) {
						if (s == 1) {
							// console.log(lists[e].title.indexOf(keyWord))
							if (lists[e].title.indexOf(keyWord) >= 0) {
								arr.push(lists[e]);
							}
						} else {
							// console.log(lists[e].schMc.indexOf(keyWord))
							if (lists[e].schMc.indexOf(keyWord) >= 0) {
								arr.push(lists[e]);
							}
						}
					}
					if (arr.length != 0) {
						list[i].list = arr
						arr2.push(list[i])
					}
				}
				return arr2;
			},
			onCancel() {
				// console.log("取消")
				// Toast('取消');
				this.findActivitydata = this.findActivity22;
				this.activeNames = 0
			},
			onCancele() {
				// console.log("取消")
				// Toast('取消');
				this.findActivityByType = this.findActivityByType22;
				this.activeNamese = 0
			},
			onCanceless() {
				// console.log("取消",this.findActivityByTypess)
				// Toast('取消');
				this.findActivityByTypes = this.findActivityByTypess;
				this.activeNamesess = 0
			},
			onCancelessYY() {
				// console.log("取消",this.findActivityByTypess)
				// Toast('取消');
				this.findActivityYY = this.findActivityYYdata;
				this.activeNamesessYY = 0
			},

			kfCode(e = 2690414527) {
				if (e == null) {
					e = 2690414527
				}
				// console.log(e);
				// window.location.href= ` http://wpa.qq.com/msgrd?v=3&uin=`+e+`&site=在线客服&menu=yes`
				window.location.href = `mqqwpa://im/chat?chat_type=wpa&uin=` + e + `&version=1&src_type=web&web_src=oicqzone.com`;
			},
			onClickNenu(e) {
				// if (e != 1) {
				//   Toast.fail('暂未开放哦');
				// }
				this.current = e
			},
			onClickCart(e, value, name, s, type, tab, lei) {
				// var that = this
				// this.$router.push('cart');
				// if (!that.code) {
				//   return Notify({ type: 'danger', message: '请填写暗号' });
				// }
				this.isFirstLoad = false;
				this.code = value;
				this.name = name;
				this.getCode(value, s, type, tab, lei)
			},
			getCode(code, e, type, tab, lei) {
				var storage = window.sessionStorage;
				storage.setItem('tab', tab);

				if (e.wxUrl) {
					this.$router.push({
						name: 'group_qq',
						query: {
							wxUrl: e.wxUrl,
							title: e.title,
							code: code,
							type: type,
							lei: lei,
						}
					})
				} else {
					this.$router.push({
						name: 'group_qq',
						query: {
							qqUrl: e.qqUrl,
							qq: e.qq,
							title: e.title,
							code: code,
							type: type,
							lei: lei,
						}
					})
				}
			},
			getActivity() {
				https.fetchGet('/api/wx/lc/findActivityByType?type=major').then(res => {
					if (res.data && res.data.data) {
						this.findActivityByType22 = res.data.data.items
						this.findActivityByType = this.findActivityByType22
					}
				}).catch(err => {
					this.loading = false
					Notify({
						type: 'warning',
						message: '当前人数过多，请稍后重试'
					});
				})
				https.fetchGet('/api/wx/lc/findActivityByType?type=major2').then(res => {
					
					if (res.data && res.data.data &&res.data.code == 200 ) {
						this.findActivityByTypess = res.data.data.items;
						this.findActivityByTypes = this.findActivityByTypess;
						console.log("res",res)
					}
				}).catch(err => {
					this.loading = false
					Notify({
						type: 'warning',
						message: '当前人数过多，请稍后重试'
					});
				})
				https.fetchGet('/api/wx/lc/findActivity/22').then(res => {
					if (res.data && res.data.data) {
						// this.introduce = res.data.data
						this.findActivity22 = res.data.data.items;
						this.findActivitydata = this.findActivity22;
					}
				}).catch(err => {
					this.loading = false
					Notify({
						type: 'warning',
						message: '当前人数过多，请稍后重试'
					});
				})
				https.fetchGet('/api/wx/lc/findActivityByType?type=yyq').then(res => {
					if (res.data && res.data.data) {
						// this.introduce = res.data.data
						var data = res.data.data.items;
						var listd = [];
						this.findActivityYY = res.data.data.items;
						this.findActivityYYdata = this.findActivityYY;
						for (var i in data) {
							var lists = data[i].list;
							for (var s in lists) {
								if (lists[s].qqUrl) {
									QRCode.toDataURL(lists[s].qqUrl, {
										errorCorrectionLevel: 'H'
									}, function(err, url) {
										console.log(url)
										lists[s].url_img = url
										listd.push(lists[s])
									})
								} else {
									listd.push(lists[s])
								}
							}
						}
						this.YYData = listd
					}
				}).catch(err => {
					this.loading = false
					Notify({
						type: 'warning',
						message: '当前人数过多，请稍后重试'
					});
					console.log(err)
				})
			},
			kfCode_img(e) {
				if (e == null) {
					e = 2690414527
				}
				if (e) {
					this.isFirstLoad = false;
					this.qr = e;
				} else {
					Toast.fail('获取失败');
				}
			},
			goGroup() {
				this.$router.push({
					name: 'group_qq',
					query: {
						id: "1"
					}
				})
			},
			copy(e, value) {
				try {
					value = value || '2690414527'
					const input = document.createElement('textarea')
					input.value = value
					document.body.appendChild(input)
					input.select()
					document.execCommand('Copy')
					document.body.removeChild(input)
					Toast.success('客服QQ号复制成功');
				} catch (e) {
					Toast.fail('复制失败');
				}
			}
		}
	};
</script>

<style>
	.school_group_text {
		font-size: 30px;
		text-align: center;
		padding: 40px 60px;
		margin-top: 100px;
		line-height: 52px;
		color: red;
	}

	.van-tabs__nav--line {
		width: 90%;
		margin: 0 auto;
	}

	.yyBtn {
		width: 508px;
		height: 88px;
		background: linear-gradient(84deg, #2AC59A 0%, #00C080 100%);
		box-shadow: 0px 10px 20px 0px rgba(0, 192, 128, 0.33);
		border-radius: 44px;
		margin: 40px auto 55px;
		line-height: 88px;
		text-align: center;
		font-size: 36px;
		color: #fff;
	}

	.yyText {
		margin-top: 30px;
		font-weight: 500;
		color: #333333;
		line-height: 42px;
		font-weight: bold;
		text-align: center;
		margin-bottom: 40px;
		font-size: 30px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 48px;
	}

	.yyImg {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}

	.yyImg img {
		padding: 10px;
		box-sizing: border-box;
		width: 312px;
		height: 312px;
		background: #FFFFFF;
		border-radius: 30px;
		border: 3px solid #00C080;
	}

	.tab_iv>.yes {
		color: #fff;
		background: #00C080 !important;
	}

	.tab_iv {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
	}

	.tab_iv>div {
		padding: 12px 24px;
		background: #F5F5F5;
		border-radius: 28px;
		margin: 24px 12px;
		font-size: 28px;
	}

	.van_li .van-cell {
		padding: 34px 32px;
	}

	.van-collapse-item__content {
		background-color: #F8F8F8;
		padding: 0;

	}

	html {
		background-color: #fff;
	}

	.van-tabs__line {
		width: 60px !important;
		height: 7px;
		background-color: #00C080;
	}
</style>
<style scoped="scoped">
	.school_group {
		min-height: 700px;
		margin-top: 20px;
	}

	.IMG {
		width: 400px;
		height: 400px;
		position: fixed;
		left: 50%;
		margin-left: -200px;
		top: 50%;
		margin-top: -200px;
		background-color: red;
		z-index: 100;
	}

	.title {
		color: #FFF1A5;
		font-size: 22px;
		text-align: left;
		padding-top: 20px;
		margin-left: 30px;
	}

	.contatiner {
		background-color: #fff;
	}

	.titleD {
		width: 304px;
		height: 74px;
		background: #FFE65F;
		border-radius: 20px;
		font-weight: bold;
		font-size: 30px;
		color: #333;
		line-height: 74px;
		text-align: center;
		margin: 0 auto;
	}

	.van_li .li {
		margin-left: 70px;
		height: 110px;
		line-height: 110px;
		font-size: 32px;
		color: #191919;
	}

	.van_li .h4 {
		font-size: 32px;
		color: #333;
	}

	.van_li .li+.li {
		border-top: 1px solid #E7E7E7;
	}

	.problem {
		height: 26px;
		line-height: 26px;
		margin-top: 40px;
		color: #C1C1C1;
		text-align: center;
		font-size: 26px
	}

	.problem span {
		color: #00C080;
	}

	.van_search {
		margin-top: 40px;
	}

	.van-search {
		box-sizing: border-box;
		margin-top: 40px;
		padding: 0 30px;
	}

	.van-search__content {
		height: 80px;
		line-height: 80%;
		align-items: center;
		border-radius: 100px !important;
		background-color: #F6F6F6;
	}

	.group_span {
		width: 58px;
		height: 30px;
		background: #D3D3D3;
		border-radius: 8px;
		text-align: center;
		line-height: 30px;
		margin-left: 9px;
		font-size: 26px;
		color: #fff;
		display: inline-block;
	}

	.topNone {
		margin-top: -330px;
	}

	.code-wrapper {
		min-height: 680px;
		padding: 15px;
		display: flex;
		flex-wrap: wrap;
	}

	.code-wrapperz {
		/* background: #F2F2F2;
    border-radius: 11px;
    line-height: 48px; */
	}

	.code-selected {
		width: 212px;
		height: 116px;
		background: #F2F2F2;
		border-radius: 20px;
		margin: 14px;
		color: #333;
		font-size: 28rpx;
		line-height: 116px;
		text-align: center;
	}

	.content {
		background: #FFFFFF;
		border-radius: 17px 17px 0px 0px;
		position: relative;
		/* top: -40px; */
		overflow: hidden;
	}


	.top {
		background: url(../../../../static/no_bei.png) no-repeat;
		background-size: 100% 100%;
		background-color: #00C080;
		height: 388px;
		text-align: center;
		transition: all 1s;
	}

	.top_img {
		width: 652px;
		height: 120px;
		margin: 0 auto;
	}

	.text1 {
		width: 498px;
		height: 60px;
		background: #FFFFFF;
		border-radius: 30px;
		font-size: 30px;
		font-weight: 500;
		color: #00C080;
		line-height: 60px;
		display: inline-block;
		margin-top: -10px;
	}

	.text2 {
		height: 26px;
		font-size: 30px;
		font-weight: 400;
		color: #FFFFFF;
		margin-top: 20px;
	}

	.textdi {
		font-size: 24px;
		font-weight: 400;
		color: #C1C1C1;
		line-height: 18px;
		text-align: center;
		padding: 20px;
		margin-top: 40px;
		margin-bottom: 40px;

	}

	.menu {
		padding: 0 20px;
		display: flex;
		border-bottom: 1px solid #EAEAEA;
	}

	.menu_li {
		height: 112px;
		line-height: 112px;
		width: 50%;
		text-align: center;
		font-size: 32px;
		color: #191919;
		position: relative;
	}

	.menu_liYes {
		color: #00C080;
	}

	.menu_liYes::after {
		content: " ";
		position: absolute;
		width: 60px;
		height: 7px;
		background-color: #00C080;
		border-radius: 50px;
		bottom: -3px;
		left: 50%;
		margin-left: -30px;
	}












	/* // .contatiner {
  //   width: 100%;
  //   min-height: 100vh;
  //   background: #fff;
  // }

  // .img-wrapper {
  //   background: #ededef;
  //   padding: 15px;
  //   text-align: center;
  // }

  // .code-wrapper {
  //   width: 100%;
  //   padding: 0 5px;
  //   overflow-x: scroll;
  //   display: -webkit-box;
  //   display: flex;
  //   -webkit-flex-wrap: wrap;
  //   flex-wrap: wrap;
  //   box-sizing: border-box;
  // }

  // .code-wrapper::-webkit-scrollbar {
  //   display: none;
  // }

  // .code {
  //   display: flex;
  //   margin: 5px;
  //   margin-right: 0;
  //   justify-content: center;
  //   align-items: center;
  //   color: #666;
  //   border-radius: 6px;
  //   font-size: 14px;
  //   border: 1px solid #eee;
  //   height: 40px;
  //   padding: 0 6px;
  // }

  // .code-selected {
  //   background: rgb(107, 216, 252);
  //   border: 1px solid rgb(107, 216, 252);
  //   color: #fff;
  // }

  // .name {
  //   font-size: 20px;
  //   font-weight: bold;
  //   color: #333;
  // }

  // .remark {
  //   margin-top: 8px;
  //   margin-bottom: 24px;
  //   color: #999;
  //   font-size: 13px;
  // }

  // .user {
  //   &-poster {
  //     width: 100%;
  //     height: 53vw;
  //     display: block;
  //   }

  //   &-group {
  //     margin-bottom: 15px;
  //   }
  // }

  // .content {
  //   width: 90%;
  //   margin-left: 5%;
  //   margin-top: 3%;
  // }

  // .qr {
  //   width: 100%;
  // }

  // .cg {
  //   margin-top: 3%;
  //   margin-bottom: 3%;
  // }

  // .tip-wrapper {
  //   width: 100%;
  //   padding: 16px 0;
  //   text-align: center;
  // }

  // .tip {
  //   font-size: 13px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  // }

  // .copy-tip {
  //   font-size: 11px;
  //   color: #aaa;
  //   padding-top: 6px;
  // }

  // .van-button--mini {
  //   min-width: 66px;
  // }

  // .color {
  //   color: #3d9dfd;
  // } */
</style>
